import { withPrefix } from 'utils/prefix'

/**
 * 1st level location following:
 *
 * Example 1: (without the prefix /docs)
 *
 * input: /accept-payments/content-security-policy
 * output: /accept-payments
 *
 * Example 2: (with the prefix /docs)
 *
 * input: /docs/accept-payments/content-security-policy
 * output: /docs/accept-payments
 */

export function getFirstLevelPathname(path = '') {
	const prefixedRoot = withPrefix('/')

	if (!path || path === '/' || path === prefixedRoot) {
		return path
	}

	if (path.startsWith(prefixedRoot)) {
		path = path.replace(prefixedRoot, '')
	}

	if (!path.startsWith('/')) {
		path = `/${path}`
	}

	const parts = (path || '').split('/')

	return withPrefix(`/${parts[1]}`)
}

export default function getFirstLevelLocation(location) {
	const firstLevelPathname = getFirstLevelPathname(`${location.pathname}${location.hash}`)
	return {
		...location,
		key: 'level-1',
		href: `${location.origin}${firstLevelPathname}`,
		pathname: firstLevelPathname,
		search: '',
		hash: '',
	}
}
